<template>
    <div class="section text-center mt-4" v-if="loading">
        <div class="spinner-border text-primary big-spinner" role="status"></div>
        <div class="mt-2 text-muted fw-bold mal-text">Please wait...</div>
    </div>
    
    <div class="exam-header-sticky" v-if="!loading && exam_started">
        <div class="progress-container glass-effect">
            <span class="text-primary mal-text fw-bold">ഉത്തരം നൽകിയത്</span>
            <span class="badge-progress">{{answerStatus}} / {{answers_list.length}}</span>
        </div>
    </div>

    <!-- If there are no paid members eligible for this exam -->
    <div class="section mt-3 px-3" v-if="!loading && !exam_started && start && responseData.members.length == 0">
        <div class="alert alert-danger soft-alert text-center mal-text border-0 shadow-sm rounded-4 py-4">
            <b>{{ responseData.message }}</b>
        </div>
    </div>

    <!-- Show only paid members for this exam -->
    <div class="section mt-3 px-3" v-if="!loading && !exam_started && start && responseData.members.length > 0">
        <div class="instruction-title text-center text-primary mal-text mb-3 fw-bold">
            {{ memberListInstruction }}
        </div>
        <div class="member-list-wrapper">
            <a href="javascript:void(0)" @click="selectMember(member)" class="member-card modern-card" :disabled="member.disabled" v-for="member in responseData.members" v-bind:key="member.id">
                <div class="d-flex align-items-center w-100">
                    <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="avatar-img shadow-sm" />
                    <div class="ms-3 flex-grow-1">
                        <div class="text-muted small fw-bold">{{ member.reg_number }}</div>
                        <h5 class="text-primary mb-1 fw-bold">{{ member.name }}</h5>
                        <div class="badge-soft mt-1" :class="member.exam_color">{{ member.exam_status }}</div>
                    </div>
                    <div class="text-primary fs-1">
                        <ion-icon :name="member.icon"></ion-icon>
                    </div>
                </div>
            </a>
        </div>
    </div>

    <div class="section mt-3 px-3" v-if="!loading && !start">
        <div class="card premium-card border-0 shadow-sm rounded-4 mb-4">
            <div class="card-header bg-transparent border-0 text-center pt-4 pb-0">
                <h4 class="mal-text fw-bold text-dark mb-0">പരീക്ഷ എഴുതുന്ന ആളുടെ വിവരങ്ങൾ</h4>
            </div>
            <div class="card-body">
                <div class="info-list">
                    <div class="info-row" v-if="selected_exam && examDisplayName">
                        <span class="mal-text text-muted">പരീക്ഷ</span>
                        <span class="fw-bold text-dark">{{ examDisplayName }}</span>
                    </div>
                    <div class="info-row">
                        <span class="mal-text text-muted">പേര്</span>
                        <span class="fw-bold text-dark">{{ selected_member.name }}</span>
                    </div>
                    <div class="info-row" v-if="selected_member.category || selected_member.category_name">
                        <span class="mal-text text-muted">വിഭാഗം</span>
                        <span class="fw-bold text-dark">{{ selected_member.category_name || selected_member.category }}</span>
                    </div>
                    <div class="info-row">
                        <span class="mal-text text-muted">സ്റ്റാറ്റസ്</span>
                        <span class="badge-soft" :class="selected_member.exam_color">{{ selected_member.exam_status }}</span>
                    </div>
                    <div class="info-row" v-if="responseData.certificate_download && (selected_member.exam_done || selected_member.exam_status)">
                        <span class="mal-text text-muted">സർട്ടിഫിക്കറ്റ്</span>
                        <a :href="'https://guide.msoftit.com/print-exam-certificate-download/'+selected_member.id" class="btn btn-sm btn-outline-danger rounded-pill px-3">Download</a>
                    </div>
                    <div class="info-row" v-if="selected_member.mark">
                        <span class="mal-text text-muted">മാർക്ക്</span>
                        <span class="fw-bold text-dark" v-html="selected_member.mark"></span>
                    </div>
                    <!-- QVP Admit Card / Hall Ticket download (48+ marks, center must be assigned; backend enforces) -->
                    <div class="info-row" v-if="canDownloadQvpAdmitCard">
                        <span class="mal-text text-muted">ഹാൾ ടിക്കറ്റ്</span>
                        <button
                            type="button"
                            class="btn btn-sm btn-outline-primary rounded-pill px-3"
                            @click="downloadQvpAdmitCard"
                            :disabled="downloadingAdmitCard"
                        >
                            {{ downloadingAdmitCard ? 'Please wait...' : 'Download' }}
                        </button>
                    </div>
                </div>
                
                <div class="mt-4" v-if="!exam_started && this.responseData.members.length > 1">
                    <button type="button" class="btn btn-primary-soft w-100 mal-text action-btn rounded-4 d-flex align-items-center justify-content-between p-3" @click="openMemberModel">
                        <span class="fw-bold">മറ്റു മെമ്പർമാരെ സെലക്ട് ചെയ്യുക</span>
                        <ion-icon name="chevron-forward-outline" class="fs-4"></ion-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="section mt-3 px-3" v-if="!loading && responseData.exam_end && !start">
        <div class="alert alert-danger soft-alert text-center mal-text border-0 shadow-sm rounded-4 py-4 fw-bold">
            ക്ഷമിക്കണം. പരീക്ഷ എഴുതാനുള്ള സമയം അവസാനിച്ചു.
        </div>
    </div>

    <!-- Start exam: instructions + button (only when questions page is enabled for this exam) -->
    <div class="section mt-3 px-3" v-if="!loading && !exam_started && !start && !selected_member.exam_done && !responseData.exam_end && questionsPageEnabled">
        <div class="card premium-card border-0 shadow-sm rounded-4 mb-4">
            <div class="card-header bg-light border-0 text-center pt-3 pb-3 rounded-top-4">
                <h5 class="mal-text text-primary mb-0 fw-bold">പരീക്ഷ തുടങ്ങുന്നതിനു മുൻപ് ശ്രദ്ധിച്ചു വായിക്കുക</h5>
            </div>
            <div class="card-body p-3 bg-white rounded-bottom-4">
                <div class="card-text custom-instruction-text text-muted" v-html="this.description"></div>
            </div>
        </div>
        <button type="button" class="btn btn-primary d-flex align-items-center justify-content-between w-100 action-btn rounded-4 mb-4" @click="startExam">
            <span class="action-btn-text fw-bold">പരീക്ഷ തുടങ്ങാൻ ക്ലിക്ക് ചെയ്യുക</span>
            <ion-icon name="chevron-forward-outline" class="action-btn-icon flex-shrink-0 ms-2"></ion-icon>
        </button>
    </div>

    <!-- When questions page is disabled: only result viewing; no Start exam for those who haven't attended -->
    <div class="section mt-3 px-3" v-if="!loading && !exam_started && !start && !selected_member.exam_done && !responseData.exam_end && !questionsPageEnabled">
        <div class="alert alert-info soft-alert text-center mal-text border-0 shadow-sm rounded-4 py-4">
            <b>പരീക്ഷ എഴുതാനുള്ള ഓപ്ഷൻ ഇപ്പോൾ നിർജ്ജീവമാണ്. ഈ പരീക്ഷയിൽ ഇതുവരെ എഴുതിയവർക്ക് ഫലം മാത്രം കാണാം.</b><br>
            <span class="text-muted small">Exam writing is disabled for this exam. Only result viewing is available for those who have already attended.</span>
        </div>
    </div>

    <!-- Modals -->
    <div class="modal fade action-sheet" id="chooseMemberModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-top-4 border-0">
                <div class="modal-header border-0 pt-4 px-4">
                    <h5 class="modal-title mal-text text-primary fw-bold">
                        മെമ്പറെ സെലക്ട് ചെയ്യുക
                    </h5>
                </div>
                <div class="modal-body px-4 pb-4">
                    <div class="member-list-wrapper mt-2">
                        <a href="javascript:void(0)" @click="selectMember(member)" class="member-card modern-card mb-3" v-for="member in responseData.members" v-bind:key="member.id">
                            <div class="d-flex align-items-center w-100">
                                <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="avatar-img shadow-sm" />
                                <div class="ms-3 flex-grow-1">
                                    <div class="text-muted small fw-bold">{{ member.reg_number }}</div>
                                    <h5 class="text-dark mb-1 fw-bold">{{ member.name }}</h5>
                                </div>
                                <div class="text-primary fs-4">
                                    <ion-icon name="arrow-forward-outline"></ion-icon>
                                </div>
                            </div>
                        </a>
                    </div>
                    <button class="btn btn-light w-100 text-danger rounded-4 mt-3 py-3 fw-bold shadow-sm border-0" data-bs-dismiss="modal" @click="closeMemberModel">
                        <ion-icon name="close-outline" class="me-1 fs-5 align-middle"></ion-icon> Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Exam Start -->
    <div class="section mt-4 px-3 exam-section" v-if="!loading && exam_started && !start && !selected_member.exam_done">
        <Form @submit="updateAttempt" :validation-schema="schema">
            <div v-for="(questians, index) in selected_questians" v-bind:key="questians.id">
                <div class="section-title-wrapper mb-4" v-if="index == 0">
                    <div class="text-danger custom-instruction-text text-center px-2 bg-white rounded-3 shadow-sm py-3 instruction-text fw-bold" v-if="responseData.section_a_text" v-html="this.responseData.section_a_text"></div>
                </div>
                <div class="section-title-wrapper mb-4 mt-4" v-else-if="selected_questians[index-1].q_section != questians.q_section">
                    <div class="text-danger custom-instruction-text text-center px-2 bg-white rounded-3 shadow-sm py-3 instruction-text fw-bold" v-if="questians.q_section == 'B' && responseData.section_b_text" v-html="this.responseData.section_b_text"></div>
                    <div class="text-danger custom-instruction-text text-center px-2 bg-white rounded-3 shadow-sm py-3 instruction-text fw-bold" v-if="questians.q_section == 'C' && responseData.section_c_text" v-html="this.responseData.section_c_text"></div>
                </div>

                <div class="card question-card border-0 shadow-sm rounded-4 mb-4">
                    <div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3 px-4">
                        <span class="mal-text text-muted fw-bold">ചോദ്യം #{{ index + 1 }}</span>
                        <div class="status-indicator">
                            <div class="spinner-grow text-warning spinner-sm" role="status" v-if="!answers_list[index].a"></div>
                            <ion-icon name="checkmark-circle" class="text-success fs-1 drop-shadow" v-if="answers_list[index].a"></ion-icon>
                        </div>
                    </div>

                    <div class="card-body px-4 pb-4" v-if="questians.q_section == 'A'">
                        <h4 class="card-title mal-text fw-bold text-dark mb-4 lh-base">{{ questians.q_text }}</h4>
                        <div class="options-grid">
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'A'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionA-' + questians.id" value="A" @change="updateAttempt('update')" />
                                <span class="option-letter">A</span>
                                <span class="option-text mal-text">{{ questians.option_A }}</span>
                            </label>
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'B'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionB-' + questians.id" value="B" @change="updateAttempt('update')" />
                                <span class="option-letter">B</span>
                                <span class="option-text mal-text">{{ questians.option_B }}</span>
                            </label>
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'C'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionC-' + questians.id" value="C" @change="updateAttempt('update')" />
                                <span class="option-letter">C</span>
                                <span class="option-text mal-text">{{ questians.option_C }}</span>
                            </label>
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'D'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionD-' + questians.id" value="D" @change="updateAttempt('update')" />
                                <span class="option-letter">D</span>
                                <span class="option-text mal-text">{{ questians.option_D }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="card-body px-4 pb-4" v-if="questians.q_section == 'B'">
                        <h4 class="card-title mal-text fw-bold text-dark mb-4 lh-base">{{ questians.q_text }}</h4>
                        <div class="options-grid">
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('A')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionA-' + questians.id" value="A" @change="updateAttempt('update')" />
                                <span class="option-letter">A</span>
                                <span class="option-text mal-text">{{ questians.option_A }}</span>
                            </label>
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('B')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionB-' + questians.id" value="B" @change="updateAttempt('update')" />
                                <span class="option-letter">B</span>
                                <span class="option-text mal-text">{{ questians.option_B }}</span>
                            </label>
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('C')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionC-' + questians.id" value="C" @change="updateAttempt('update')" />
                                <span class="option-letter">C</span>
                                <span class="option-text mal-text">{{ questians.option_C }}</span>
                            </label>
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('D')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :id="'optionD-' + questians.id" value="D" @change="updateAttempt('update')" />
                                <span class="option-letter">D</span>
                                <span class="option-text mal-text">{{ questians.option_D }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="card-body px-4 pb-4" v-if="questians.q_section == 'C'">
                        <h4 class="card-title mal-text fw-bold text-dark mb-4 lh-base">{{ questians.q_text }}</h4>
                        <div class="input-wrapper">
                            <Field type="number" class="form-control form-control-lg custom-input rounded-4 bg-light border-0 py-3 px-4 fw-bold" id="name"
                            v-model="answers_list[index].a" :name="'questian' + questians.id" @change="updateAttempt('update')"  placeholder="ഉത്തരം നൽകുക" autocomplete="off" />
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    
        <button type="button" class="btn btn-success d-flex align-items-center justify-content-between w-100 action-btn rounded-4 mb-5" @click="updateattempConfirm('submit')">
            <span class="action-btn-text fw-bold">Submit ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
            <ion-icon name="checkmark-done-circle-outline" class="action-btn-icon flex-shrink-0 ms-2"></ion-icon>
        </button>
    </div>
    
    <!-- When Valued + Result Display: show only summary by default; optional "View question-wise result" -->
    <div class="section mt-3 px-3" v-if="!loading && exam_result && resultSummaryOnly && !showQuestionWiseResult">
        <button type="button" class="btn btn-primary-soft w-100 mal-text action-btn rounded-4 d-flex align-items-center justify-content-between p-3" @click="showQuestionWiseResult = true">
            <span class="fw-bold">വിശദമായ ഫലം കാണാൻ / View question-wise result</span>
            <ion-icon name="chevron-down-outline" class="fs-4"></ion-icon>
        </button>
    </div>

    <!-- Exam Results (full question-wise result); when resultSummaryOnly, show only after user expands -->
    <div class="section mt-4 px-3 exam-section" v-if="!loading && exam_result && (!resultSummaryOnly || showQuestionWiseResult)">
        <Form @submit="updateAttempt" :validation-schema="schema">
            <div v-for="(questians, index) in selected_questians" v-bind:key="questians.id">
                <div class="section-title-wrapper mb-4" v-if="index == 0">
                    <div class="text-danger custom-instruction-text text-center px-2 bg-white rounded-3 shadow-sm py-3 instruction-text fw-bold" v-if="responseData.section_a_text">{{ responseData.section_a_text }}</div>
                </div>
                <div class="section-title-wrapper mb-4 mt-4" v-else-if="selected_questians[index-1].q_section != questians.q_section">
                    <div class="text-danger custom-instruction-text text-center px-2 bg-white rounded-3 shadow-sm py-3 instruction-text fw-bold" v-if="questians.q_section == 'B' && responseData.section_b_text">{{ responseData.section_b_text }}</div>
                    <div class="text-danger custom-instruction-text text-center px-2 bg-white rounded-3 shadow-sm py-3 instruction-text fw-bold" v-if="questians.q_section == 'C' && responseData.section_c_text">{{ responseData.section_c_text }}</div>
                </div>

                <div class="card question-card border-0 shadow-sm rounded-4 mb-4" :class="{'border-success-soft': answers_r_list[index].r == 'Y', 'border-danger-soft': answers_r_list[index].r == 'N'}">
                    <div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3 px-4">
                        <span class="mal-text text-muted fw-bold">ചോദ്യം #{{ index+ 1 }}</span>
                        <div class="status-indicator">
                            <ion-icon name="checkmark-circle" class="text-success fs-1 drop-shadow" v-if="answers_r_list[index].r == 'Y'"></ion-icon>
                            <ion-icon name="close-circle" class="text-danger fs-1 drop-shadow" v-if="answers_r_list[index].r == 'N'"></ion-icon>
                        </div>
                    </div>
                    
                    <div class="card-body px-4 pb-4" v-if="questians.q_section == 'A'">
                        <h4 class="card-title mal-text fw-bold text-dark mb-4 lh-base">{{ questians.q_text }}</h4>
                        <!-- Results Grid -->
                        <div class="options-grid readonly-grid">
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'A'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :disabled="true" value="A" />
                                <span class="option-letter">A</span>
                                <span class="option-text mal-text">{{ questians.option_A }}</span>
                            </label>
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'B'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" value="B" :disabled="true" />
                                <span class="option-letter">B</span>
                                <span class="option-text mal-text">{{ questians.option_B }}</span>
                            </label>
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'C'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" value="C" :disabled="true" />
                                <span class="option-letter">C</span>
                                <span class="option-text mal-text">{{ questians.option_C }}</span>
                            </label>
                            <label class="option-tile" :class="{'selected': answers_list[index].a === 'D'}">
                                <Field type="radio" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" value="D" :disabled="true" />
                                <span class="option-letter">D</span>
                                <span class="option-text mal-text">{{ questians.option_D }}</span>
                            </label>
                        </div>
                        <div class="alert alert-danger soft-alert mt-4 mb-0 rounded-4 py-3 px-4 border-0 d-flex align-items-center" role="alert" v-if="answers_r_list[index].r == 'N'">
                            <ion-icon name="information-circle" class="me-2 fs-3"></ion-icon> 
                            <span class="fw-bold mal-text">{{ answers_r_list[index].m }}</span>
                        </div>
                        <div class="alert alert-success soft-alert mt-4 mb-0 rounded-4 py-3 px-4 border-0 d-flex align-items-center" role="alert" v-if="answers_r_list[index].r == 'Y'">
                            <ion-icon name="checkmark-done" class="me-2 fs-3"></ion-icon> 
                            <span class="fw-bold mal-text">{{ answers_r_list[index].m }}</span>
                        </div>
                    </div>

                    <div class="card-body px-4 pb-4" v-if="questians.q_section == 'B'">
                        <h4 class="card-title mal-text fw-bold text-dark mb-4 lh-base">{{ questians.q_text }}</h4>
                        <div class="options-grid readonly-grid">
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('A')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" :disabled="true" value="A" />
                                <span class="option-letter">A</span>
                                <span class="option-text mal-text">{{ questians.option_A }}</span>
                            </label>
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('B')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" value="B" :disabled="true" />
                                <span class="option-letter">B</span>
                                <span class="option-text mal-text">{{ questians.option_B }}</span>
                            </label>
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('C')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" value="C" :disabled="true" />
                                <span class="option-letter">C</span>
                                <span class="option-text mal-text">{{ questians.option_C }}</span>
                            </label>
                            <label class="option-tile checkbox-tile" :class="{'selected': (answers_list[index].a || []).includes('D')}">
                                <Field type="checkbox" class="d-none" v-model="answers_list[index].a" :name="'questian' + questians.id" value="D" :disabled="true" />
                                <span class="option-letter">D</span>
                                <span class="option-text mal-text">{{ questians.option_D }}</span>
                            </label>
                        </div>
                        <div class="alert alert-danger soft-alert mt-4 mb-0 rounded-4 py-3 px-4 border-0 d-flex align-items-center" role="alert" v-if="answers_r_list[index].r == 'N'">
                            <ion-icon name="information-circle" class="me-2 fs-3"></ion-icon> 
                            <span class="fw-bold mal-text">{{ answers_r_list[index].m }}</span>
                        </div>
                        <div class="alert alert-success soft-alert mt-4 mb-0 rounded-4 py-3 px-4 border-0 d-flex align-items-center" role="alert" v-if="answers_r_list[index].r == 'Y'">
                            <ion-icon name="checkmark-done" class="me-2 fs-3"></ion-icon> 
                            <span class="fw-bold mal-text">{{ answers_r_list[index].m }}</span>
                        </div>
                    </div>

                    <div class="card-body px-4 pb-4" v-if="questians.q_section == 'C'">
                        <h4 class="card-title mal-text fw-bold text-dark mb-4 lh-base">{{ questians.q_text }}</h4>
                        <div class="input-wrapper">
                            <Field type="text" class="form-control form-control-lg custom-input rounded-4 bg-light border-0 py-3 px-4 fw-bold" id="name" readonly
                            v-model="answers_list[index].a" :name="'questian' + questians.id" placeholder="" autocomplete="off" />
                            <div class="alert alert-danger soft-alert mt-4 mb-0 rounded-4 py-3 px-4 border-0 d-flex align-items-center" role="alert" v-if="answers_r_list[index].r == 'N'">
                                <ion-icon name="information-circle" class="me-2 fs-3"></ion-icon> 
                                <span class="fw-bold mal-text">{{ answers_r_list[index].m }}</span>
                            </div>
                            <div class="alert alert-success soft-alert mt-4 mb-0 rounded-4 py-3 px-4 border-0 d-flex align-items-center" role="alert" v-if="answers_r_list[index].r == 'Y'">
                                <ion-icon name="checkmark-done" class="me-2 fs-3"></ion-icon> 
                                <span class="fw-bold mal-text">{{ answers_r_list[index].m }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    </div>
    
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" :yes_button="dialog_yes_button" :no_button="dialog_no_button" ref="dialog_model"></dialog-model>
</template>

<script>
import $ from "jquery";
import { Form, Field } from "vee-validate";
import UserService from "../../../services/user.service";
import AlertModel from "./../../layouts/AlertModel.vue";
import DialogModel from "./../../layouts/DialogModel.vue";
export default {
    name: "Exam",
    components: {
        AlertModel,
        DialogModel,
        Form,
        Field,
    },
    data() {
        return {
            loading: false,
            responseData: {
                exam: [],
                members: [],
            },
            description: [],
            selected_member: [],
            selected_exam: [],
            selected_questians: [],
            answers_list: [],
            answers_r_list: [],
            exam_started: false,
            start: true,
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            dialog_yes_button: "",
            dialog_no_button: "",
            countDown: 30,
            exam_result: false,
            section_old:'D',
            /** Exam name from QVP landing content (same source as QVPExamRegistration) when get-exam-members returns generic "QVP Exam" */
            landingExamName: null,
            /** When true, user has expanded to see question-wise result (used when resultSummaryOnly is true) */
            showQuestionWiseResult: false,

            downloadingAdmitCard: false,

        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        /** Exam display name (e.g. "Al-BAYAN EXAM 2026") – prefer landing content name, else form_heading || name from API */
        examDisplayName() {
            if (this.landingExamName) return this.landingExamName;
            const exam = this.selected_exam;
            if (!exam || typeof exam !== 'object') return '';
            return (exam.form_heading && String(exam.form_heading).trim())
                || (exam.name && String(exam.name).trim())
                || '';
        },
        splitArray(desc) {
            return desc.split('|');
        },
        answerStatus() {
            let count = 0;
            this.answers_list.forEach(element => {
                console.log(element);
                if(element.a != null && element.a != ""){
                    count ++;
                }
            });
            return count;
        },
        /** When exam has Result Display (and candidate has attended), show only result summary by default – no need to go through questions page */
        resultSummaryOnly() {
            const exam = this.responseData && this.responseData.exam;
            const rd = exam && (exam.result_display === 'Y' || exam.result_display === true);
            return !!(rd && this.selected_member && this.selected_member.exam_done);
        },
        /** Questions page (Start exam / write exam) enabled for this exam. When N, only result viewing; no Start button for non-attended. */
        questionsPageEnabled() {
            const exam = this.responseData && this.responseData.exam;
            if (!exam) return true;
            const q = exam.questions_page_enabled;
            return q !== 'N' && q !== false;
        },
        /** Instruction for member list: "View result" when exam has result display and all have attended */
        memberListInstruction() {
            const exam = this.responseData && this.responseData.exam;
            const rd = exam && (exam.result_display === 'Y' || exam.result_display === true);
            const members = Array.isArray(this.responseData.members) ? this.responseData.members : [];
            const allDone = members.length > 0 && members.every(m => m && m.exam_done);
            if (rd && allDone) {
                return 'താങ്കളുടെ പരീക്ഷ ഫലം കാണാൻ മെമ്പറെ സെലക്ട് ചെയ്യുക / Select member to view result';
            }
            return 'താങ്കളുടെ മൊബൈൽ നമ്പറിന് കീഴിലുള്ള മെമ്പറെ പരീക്ഷ എഴുതുന്നതിനായി സെലക്ട് ചെയ്യുക';
        }
        ,
        /** exam registration id from URL query (legacy fallback) */
        examRegId() {
            const q = this.$route && this.$route.query ? this.$route.query : {};
            const raw = q.exam_reg_id || q.examRegId || q.reg_id || null;
            if (raw == null || raw === '') return null;
            const n = parseInt(String(raw), 10);
            return Number.isNaN(n) ? null : n;
        },
        /** use the currently selected member's registration id when available */
        effectiveExamRegId() {
            const member = this.selected_member || {};
            const raw = member.id ?? member.exam_reg_id ?? this.examRegId;
            if (raw == null || raw === '') return null;
            const n = parseInt(String(raw), 10);
            return Number.isNaN(n) ? null : n;
        },
        currentExamId() {
            const raw = this.$route && this.$route.params ? this.$route.params.id : null;
            if (raw == null || raw === '') return null;
            const n = parseInt(String(raw), 10);
            return Number.isNaN(n) ? null : n;
        },
        /** Extract numeric marks from selected_member.mark HTML/text */
        selectedMemberMarksValue() {
            const m = this.selected_member && this.selected_member.mark != null ? String(this.selected_member.mark) : '';
            if (!m) return null;
            // Extract first numeric like "52.00" from "52.00/60..." or similar
            const match = m.match(/(\d+(\.\d+)?)/);
            if (!match) return null;
            const v = Number(match[1]);
            return Number.isFinite(v) ? v : null;
        },
        /** Show download when QVP + 48+ marks + have examRegId */
        canDownloadQvpAdmitCard() {
            const examType = (this.responseData && this.responseData.exam && this.responseData.exam.exam_type) ? String(this.responseData.exam.exam_type) : '';
            const isQvp = examType.toUpperCase() === 'QVP' || (this.$route && String(this.$route.path || '').includes('online-exam'));
            const marks = this.selectedMemberMarksValue;
            return !!(isQvp && this.effectiveExamRegId && marks != null && marks >= 48);
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        }
        this.$root.updateParent("Loading...");

        this.getMembers();
        window.onpopstate = function() {
            //   if ($("body").hasClass("modal-open")) {
            //     location.reload();
            //   }
            this.backAction();
        };
    },
    methods: {
        downloadQvpAdmitCard() {
            const regId = this.effectiveExamRegId;
            if (!regId) return;
            this.downloadingAdmitCard = true;
            // API returns signed link; backend also checks marks + center assignment
            UserService.addAdmin('qvp-admit-card-pdf-link', {
                id: regId,
                exam_id: this.currentExamId,
            })
                .then((response) => {
                    const payload = response?.data;
                    const link = payload?.data?.link;
                    if (payload?.status === 'success' && link) {
                        window.location.href = link;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = payload?.message || 'Admit card not available.';
                        this.$refs.alert_model.openModel();
                    }
                })
                .catch(() => {
                    this.alert_type = 'Error';
                    this.alert_message = 'Admit card download failed.';
                    this.$refs.alert_model.openModel();
                })
                .finally(() => {
                    this.downloadingAdmitCard = false;
                });
        },
        startTimer(duration) {
            var timer = duration,
                minutes, seconds;
            let parent = this;
            setInterval(function() {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                parent.$root.updateMinutes(minutes);
                parent.$root.updateSeconds(seconds);
                if (minutes == 0 && seconds == 0) {
                    parent.updateAttempt('time_over_submit');

                }
                if (--timer < 0) {
                    timer = duration;
                }
            }, 1000);
        },
        backAction() {
            this.dialog_action_params = {};
            this.dialog_message = "ശരിക്കും ബാക്കിലേക്ക് പോകണോ?";
            this.dialog_action = "backActionConfirm";
            this.$refs.dialog_model.openModel();
        },
        backActionConfirm() {
            alert("back");
        },
        selectMember(member) {
            this.loading = true;
            this.start = false;
            this.showQuestionWiseResult = false;
            this.selected_member = member;
            if (member.exam_done) {
                this.selected_questians = member.questians;
                this.answers_list = member.questians_r;
                this.answers_r_list = member.questians_a;
                this.exam_result = true;
            }
            this.loading = false;
        },
        closeMemberModel() {
            this.loading = false;
            $("#chooseMemberModel").modal("hide");
        },
        openMemberModel() {
            this.loading = true;
            this.start = true;
            this.loading = false;
            this.selected_questians = [];
            this.answers_list = [];
            this.answers_r_list = [];
            this.exam_result = false;
            // $("#chooseMemberModel").modal("show");
        },
        startExam() {
            this.dialog_action_params = {};
            this.dialog_message = this.selected_exam.exam_start_text;
            this.dialog_action = "startExamConfirm";
            this.dialog_yes_button = "തുടങ്ങുക";
            this.dialog_no_button = "വേണ്ട";
            this.$refs.dialog_model.openModel();
        },
        startExamConfirm() {
            this.loading = true;
            this.storeAttempt();
            //   this.getQuestians();
            this.exam_started = true;
        },
        /** Load exam name from QVP landing content (same as QVPExamRegistration) so we show e.g. "Al-BAYAN EXAM 2026" instead of generic "QVP Exam" */
        loadLandingExamName(examId) {
            if (!examId) return;
            const idStr = String(examId);
            UserService.addAdmin('get-landing-content', { page: 'qvp', language: 'ml' }).then(
                (response) => {
                    if (response.data && response.data.status === 'success' && response.data.data) {
                        const data = response.data.data;
                        const forms = Array.isArray(data.exam_forms) ? data.exam_forms : (data.exam_form ? [data.exam_form] : []);
                        const exam = forms.find((e) => {
                            if (!e) return false;
                            if (e.id != null && String(e.id) === idStr) return true;
                            const url = (e.button_url || '').toString();
                            return url.includes('/online-exam/' + idStr) || url.includes(idStr);
                        });
                        if (exam) {
                            const name = (exam.form_heading && String(exam.form_heading).trim())
                                || (exam.name && String(exam.name).trim())
                                || '';
                            if (name) {
                                this.landingExamName = name;
                                this.$root.updateParent(name);
                            }
                        }
                    }
                }
            ).catch(() => {});
        },
        getMembers() {
            this.loading = true;
            this.landingExamName = null;
            let data = {
                exam_id: this.$route.params.exam,
            };
            UserService.authPostRequest(`get-exam-members`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.responseData = response.data.data;

                        // Filter members on frontend: only keep those with payment_status === 'Paid'
                        const allMembers = Array.isArray(this.responseData.members) ? this.responseData.members : [];
                        const paidOnly = allMembers.filter(m => m && m.payment_status === 'Paid');

                        // Further scope by query params when coming from QVP registration
                        const q = this.$route.query || {};
                        let scoped = paidOnly;

                        if (q.exam_reg_id) {
                            const targetId = String(q.exam_reg_id);
                            scoped = scoped.filter(m => {
                                const mid = m.id != null ? String(m.id) : '';
                                const mexam = m.exam_reg_id != null ? String(m.exam_reg_id) : '';
                                return mid === targetId || mexam === targetId;
                            });
                        }

                        if (q.category) {
                            const cat = String(q.category).toLowerCase();
                            scoped = scoped.filter(m => {
                                const mCat =
                                    (m.category && String(m.category).toLowerCase()) ||
                                    (m.category_name && String(m.category_name).toLowerCase()) ||
                                    '';
                                return mCat === cat;
                            });
                        }

                        this.responseData.members = scoped;

                        this.selected_exam = this.responseData.exam;
                        this.description = response.data.data.description;
                        if (response.data.data.live_exam) {
                            this.selected_questians = response.data.data.live_exam.questians;
                            this.answers_list = response.data.data.live_exam.answers_list;
                            this.selected_member = response.data.data.live_exam.member;
                            if (response.data.data.live_exam.bal_time > 0) {
                                var fiveMinutes = response.data.data.live_exam.bal_time;
                                this.startTimer(fiveMinutes);
                            }
                            this.exam_started = true;
                            this.start = false;
                            this.loading = false;
                        } else {
                            if (this.responseData.members.length == 1) {
                                this.selected_member = this.responseData.members[0];
                                this.exam_started = false;
                                this.start = false;
                                this.showQuestionWiseResult = false;
                                this.loading = false;
                                if (this.responseData.members[0].exam_done) {
                                    this.selected_questians = this.responseData.members[0].questians;
                                    this.answers_list = this.responseData.members[0].questians_r;
                                    this.answers_r_list = this.responseData.members[0].questians_a;
                                    this.exam_result = true;
                                }
                            } else {
                                this.exam_started = false;
                                this.start = true;
                                this.loading = false;
                            }
                        }
                        const exam = this.responseData.exam;
                            const examName = (exam && (exam.form_heading || exam.name)) || 'QVP Exam';
                            this.$root.updateParent(examName);
                            this.loadLandingExamName(this.$route.params.exam);
                    } else {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.responseData = response.data.data;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = "Warning";
                    this.alert_message = (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        getQuestians() {
            this.loading = true;
            let data = {
                exam_id: this.$route.params.exam,
                exam_registration_id: this.selected_member.id,
            };
            UserService.authPostRequest(`get-exam-questians`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.responseData = response.data.data;
                        this.loading = false;
                    } else {
                        this.responseData = response.data.data;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        storeAttempt() {
            this.loading = true;
            let data = {
                exam_id: this.$route.params.exam,
                exam_registration_id: this.selected_member.id,
            };
            UserService.authPostRequest(`store-attempt`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.responseData = response.data.data;
                        console.log(this.responseData);
                        this.selected_questians = response.data.data.questians;
                        this.answers_list = response.data.data.answers_list;
                        var fiveMinutes = this.selected_exam.max_time * 60;
                        this.startTimer(fiveMinutes);
                        this.loading = false;
                    } else {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.responseData = response.data.data;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = "Warning";
                    this.alert_message = (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        updateattempConfirm(type) {
            this.dialog_action_params = type;
            this.dialog_message = this.selected_exam.exam_submit_text;
            this.dialog_action = "updateAttempt";
            this.dialog_yes_button = "സബ്മിറ്റ്";
            this.dialog_no_button = "വേണ്ട";
            this.$refs.dialog_model.openModel();
        },
        updateAttempt(type) {
            if (type != "update") {
                this.loading = true;
            }

            let data = {
                exam_id: this.$route.params.exam,
                exam_registration_id: this.selected_member.id,
                answers_list: this.answers_list,
                type: type,
            };
            UserService.authPostRequest(`update-attempt`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.responseData = response.data.data;
                        if (type == "submit") {
                            this.alert_type = "Success";
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            setTimeout(function() {
                                location.reload();
                            }, 4000);
                        } else if (type == 'time_over_submit') {
                            this.alert_type = "Success";
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            setTimeout(function() {
                                location.reload();
                            }, 3000);
                        }
                        this.loading = false;
                    } else {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.responseData = response.data.data;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = "Warning";
                    this.alert_message = (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>

<style scoped>
/* Base overrides */
.spinner-sm {
    width: 24px;
    height: 24px;
}

.big-spinner {
    width: 3.5rem;
    height: 3.5rem;
}

.mal-text {
    font-size: 17px !important;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* Sticky Header */
.exam-header-sticky {
    position: sticky;
    top: 60px; /* Adjust according to top navbar */
    z-index: 1000;
    padding: 6px 12px;
    transition: all 0.3s ease;
}

.glass-effect {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 999px;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
    border: 1px solid rgba(255,255,255,0.6);
}

.badge-progress {
    background: #0d6efd;
    color: white;
    padding: 4px 10px;
    border-radius: 20px;
    font-weight: 700;
    font-size: 14px;
    box-shadow: 0 4px 10px rgba(13, 110, 253, 0.25);
}

/* Alerts & Badges */
.soft-alert {
    background-color: #fff4f4;
    color: #dc3545;
}

.alert-success.soft-alert {
    background-color: #f0fdf4;
    color: #198754;
}

.badge-soft {
    display: inline-block;
    padding: 5px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    background: #f1f5f9;
    color: #475569;
}
.badge-soft.text-success, .badge-soft.success { background: #dcfce7; color: #166534; }
.badge-soft.text-danger, .badge-soft.danger { background: #fee2e2; color: #991b1b; }
.badge-soft.text-warning, .badge-soft.warning { background: #fef3c7; color: #92400e; }

/* Cards & Lists */
.modern-card {
    display: block;
    background: white;
    padding: 12px;
    border-radius: 14px;
    margin-bottom: 10px;
    text-decoration: none;
    transition: all 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
    border: 1px solid #f1f5f9;
}

.modern-card:active, .modern-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.05);
    border-color: #e2e8f0;
}

.avatar-img {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid white;
}

.premium-card {
    transition: all 0.3s ease;
    border: 1px solid #f1f5f9;
}

.info-list .info-row {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px dashed #e2e8f0;
    align-items: flex-start;
    gap: 12px;
}
.info-list .info-row > *:first-child {
    flex-shrink: 0;
}
.info-list .info-row > *:last-child {
    text-align: right;
    word-break: break-word;
}
.info-list .info-row:last-child {
    border-bottom: none;
}

.btn-primary-soft {
    background: #eff6ff;
    color: #2563eb;
    border: none;
    transition: all 0.2s;
}
.btn-primary-soft:hover, .btn-primary-soft:active {
    background: #dbeafe;
    color: #1d4ed8;
}

/* Exam Options Styling */
.options-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.option-tile {
    display: flex;
    align-items: center;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.option-tile:hover {
    background: #f1f5f9;
    border-color: #e2e8f0;
}

.option-tile.selected {
    background: #eff6ff;
    border-color: #3b82f6;
    box-shadow: 0 4px 15px rgba(59, 130, 246, 0.15);
}

.option-letter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: white;
    border-radius: 10px;
    font-weight: 700;
    color: #64748b;
    margin-right: 12px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    transition: all 0.2s;
    font-size: 15px;
}

.option-tile.selected .option-letter {
    background: #3b82f6;
    color: white;
    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}

.option-text {
    flex-grow: 1;
    color: #334155;
    font-weight: 500;
}

.option-tile.selected .option-text {
    color: #0f172a;
    font-weight: 600;
}

.checkbox-tile {
    border-radius: 14px;
}

.readonly-grid .option-tile {
    cursor: default;
}
.readonly-grid .option-tile:hover {
    background: #f8fafc;
    border-color: #f1f5f9;
}
.readonly-grid .option-tile.selected {
    background: #eff6ff;
    border-color: #3b82f6;
}

/* Custom Input */
.custom-input {
    border: 2px solid #e2e8f0 !important;
    transition: all 0.2s;
    box-shadow: none !important;
}
.custom-input:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15) !important;
    background: white !important;
}
.custom-input:disabled, .custom-input[readonly] {
    background-color: #f8fafc !important;
    opacity: 1;
    color: #475569;
}

.border-success-soft { border: 2px solid #bbf7d0 !important; }
.border-danger-soft { border: 2px solid #fecaca !important; }

/* Status Indicators */
.drop-shadow {
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

.instruction-text {
    font-size: 15px;
}

.btn-lg {
    padding-top: 14px;
    padding-bottom: 14px;
}

/* Action Button Styles */
.action-btn {
    height: auto;
    min-height: 52px;
    padding: 12px 16px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12) !important;
    border-radius: 12px !important;
    transition: box-shadow 0.2s ease, transform 0.15s ease;
}
.action-btn:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}
.action-btn-text {
    font-size: 15px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.35;
    white-space: normal;
    text-align: left;
}
.action-btn-icon {
    font-size: 22px;
    line-height: 1;
}

/* Custom Instruction Block */
.custom-instruction-text {
    font-size: 15px;
    line-height: 1.5;
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    color: #475569;
}
.custom-instruction-text :deep(p) {
    margin-bottom: 12px;
}
.custom-instruction-text :deep(ul), .custom-instruction-text :deep(ol) {
    padding-left: 22px;
    margin-bottom: 12px;
}
.custom-instruction-text :deep(li) {
    margin-bottom: 6px;
}
</style>
